import { Box, Button, Typography } from '@oresundsbron/bridge-ui';
import { useTranslation } from 'next-i18next';
import { FC, PropsWithChildren } from 'react';
import { DefaultLink } from '~/components/Links/DefaultLink';

export const OresundPayInfo: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation(['common'], {
    nsMode: 'fallback',
  });

  return (
    <Box className="col-span-full flex flex-col">
      <Typography className="mb-4">{children}</Typography>
      <Button
        as={DefaultLink}
        href="/account/login"
        intent="outlined"
        className="ml-auto mr-0"
      >
        {t('action.myAccount')}
      </Button>
    </Box>
  );
};
